import CollegeStudentView from './CollegeStudentView';

export default CollegeStudentView;



// WEBPACK FOOTER //
// ./src/views/CollegeStudentView/index.js